import React from "react";
import "./MacVideoWarning.css";

const MacVideoWarning = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleGetApp = () => {
    window.open("https://www.shutterencoder.com/", "_blank");
    onClose();
  };

  return (
    <div className="mac-warning-overlay" onClick={onClose}>
      <div className="mac-warning-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mac-warning-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15v-2h2v2h-2zm0-10v6h2V7h-2z" fill="currentColor"/>
          </svg>
        </div>

        <h2 className="mac-warning-title">فرمت فایل پشتیبانی نمی‌شود</h2>

        <p className="mac-warning-text">
          مرورگر macOS ممکن است از فرمت <strong>MKV</strong> به خوبی پشتیبانی
          نکند. برای پخش این فایل، آن را به فرمت <strong>MP4</strong> تبدیل کنید.
        </p>

        <div className="mac-solution-box">
          <div className="mac-solution-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
            </svg>
          </div>
          <div className="mac-solution-content">
            <p className="mac-solution-title">راه‌حل</p>
            <p className="mac-solution-text">
              از نرم‌افزار <strong>Shutter Encoder</strong> برای تبدیل سریع و
              رایگان MKV به MP4 استفاده کنید.
            </p>
          </div>
        </div>

        <div className="mac-warning-actions">
          <button className="mac-btn primary" onClick={handleGetApp}>
            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 9v-3c0-1.1-.9-2-2-2h-6c-1.66 0-3 1.34-3 3v3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-4 6v2h-4v-2h-2l4-4 4 4h-2z"/>
            </svg>
            دانلود Shutter Encoder
          </button>
          <button className="mac-btn secondary" onClick={onClose}>
            متوجه شدم
          </button>
        </div>
      </div>
    </div>
  );
};

export default MacVideoWarning;
